import type {
  PlaybookAccessAttributes,
  PlaybookAccessAttributes2,
  PlaybookAccessGrant,
  PlaybookAccessLevel,
} from '~/api/atlas/typedefs.autogen';
import type { AccessGrant } from '~/features/access-control/types/AccessControl';
import type { ResourceAccess } from '~/redux/api/methods/access-control/accessGrantMapper';

import { EVERYONE_PRINCIPAL_ID } from '~/features/access-control/types/AccessControl';

const EVERYONE_PRINCIPAL_NAME = 'Anyone in organization';

export function mapPlaybookAccessResponse(
  response: PlaybookAccessAttributes,
): ResourceAccess {
  const everyoneGrant: AccessGrant[] = response.everyone
    ? [
        {
          principal: {
            id: EVERYONE_PRINCIPAL_ID,
            name: EVERYONE_PRINCIPAL_NAME,
            type: 'everyone',
          },
          role: response.everyone,
          source: 'direct',
        },
      ]
    : [];

  return {
    grants: [
      ...everyoneGrant,
      ...(response.grants ?? []).map(
        (grant): AccessGrant => ({
          principal: { id: grant.id, name: grant.name ?? '', type: grant.type },
          role: grant.level,
          source: 'direct',
        }),
      ),
    ],
    inheritFromParent: false,
  };
}

export function mapAccessGrantsToPlaybookAccessRequest(
  grants: AccessGrant[],
): PlaybookAccessAttributes2 {
  const everyoneGrant = grants.find(
    (grant) => grant.principal.type === 'everyone',
  );

  const principalGrants: PlaybookAccessGrant[] = grants
    .filter(
      (
        grant,
      ): grant is AccessGrant & {
        principal: { type: 'user' | 'department' };
      } =>
        grant.principal.type === 'user' ||
        grant.principal.type === 'department',
    )
    .map((grant) => ({
      id: grant.principal.id,
      level: grant.role as PlaybookAccessLevel,
      type: grant.principal.type,
    }));

  return {
    everyone: everyoneGrant
      ? (everyoneGrant.role as PlaybookAccessLevel)
      : null,
    grants: principalGrants,
  };
}
